export default __webpack_public_path__ + "static/media/indimg10.51827301.webp";